import { computed } from 'vue';
import { useFlag } from '@loadsmart/vue-feature-flags';

import { useLocalStorageRef } from '@satellite/composables/useLocalStorage';
import { useAuth } from '@/composables';

export function useEnhancedYMSExperience() {
  const { meRef } = useAuth();
  const featureFlagEnhancedYMSExperience = useFlag('enable-perf-improvements');

  const userIdRef = computed(() => meRef.value?.id);
  const enhancedYMSExperience = useLocalStorageRef('warehouse.enhancedYMSExperience', false, {
    userId: userIdRef
  });

  const isEnhancedYMSExperienceEnabled = computed({
    get: () =>
      featureFlagEnhancedYMSExperience.value?.enabled && enhancedYMSExperience.get() === true,
    set: (value: boolean) => enhancedYMSExperience.set(value)
  });

  return {
    isFeatureFlagEnhancedYMSExperienceEnabled: Boolean(
      featureFlagEnhancedYMSExperience.value?.enabled
    ),
    isEnhancedYMSExperienceEnabled
  };
}
